import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is now driven by an httpOnly `access_token` cookie set by the backend.
// `withCredentials: true` ensures the cookie is sent on every request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Kept as a no-op for backwards compatibility with any lingering call sites.
// If a legacy token is still in localStorage from a previous session, clear it.
export const setToken = (t) => {
  if (!t) {
    try { localStorage.removeItem("arm_token"); } catch { /* ignore */ }
  }
};

// One-time cleanup: purge any legacy token left in localStorage.
try { localStorage.removeItem("arm_token"); } catch { /* ignore */ }
